export const applyLicense =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjIzNzg1MWNmLTZiN2YtNDY0Mi1iZGM2LTAyMDgzZjdmYWQ5NiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.nnarMIuYwpw0+5kVL84Ulm8fgAmdBFgMPSpmvbxde3kG1OP+BFf1ChC0wTnWFlXwPIXosihSaWRuE6AwgAPr3O/5XgMNC4CH7u4kBl9OuFTh1xOhe9zAjH5xEGNp2VNWwuATwg=="
  